<!--
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
-->

<template>
  <b-row class="review">
    <b-col cols="9">
      <h4 class="mt-5">{{ survey.title }}</h4>

      <div class="review-group">
        <div class="review-label">Number of questions</div>
        <div>{{ survey.noOfQuestions }}</div>
      </div>

      <div class="review-group">
        <b-row>
          <b-col>
            <div class="review-label">Sending to</div>
            <div v-for="recipient in formData.recipients" :key="recipient.email">
              <template v-if="recipient.name">
                {{ recipient.name }}
              </template>
              <em v-else>
                &lt;no name&gt;
              </em>
            </div>
          </b-col>
          <b-col>
            <div class="review-label">Email</div>
            <div v-for="recipient in formData.recipients" :key="recipient.email">
              {{ recipient.email }}
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="review-group">
        <div class="review-label">Title/Subject</div>
        <div>{{ formData.title }}</div>
      </div>

      <div class="review-group">
        <div class="review-label">Greeting</div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="formData.salutations">
          {{ formData.salutations }}
        </div>
        <div v-else>
          Default greeting of 'Hi John Doe'
        </div>
      </div>

      <div class="review-group">
        <div class="review-label">Message</div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="formData.message" />
      </div>

      <div v-if="formData.greeting != ''" class="review-group">
        <div class="review-label">Signature</div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="formData.greeting" />
      </div>

      <div class="review-group">
        <div class="review-label">Reply-To email</div>
        <div>{{ formData.contactEmail }}</div>
      </div>

      <div class="review-group">
        <div class="review-label">Notification</div>
        <div>
          You will
          <span v-if="!formData.notifyOnResponse">
            NOT
          </span>
          be notified by e-mail when the recipient submits a response to the questionnaire.
        </div>
      </div>
    </b-col>
    <b-col cols="3">
      <a :href="survey.previewUrl" class="btn btn-outline-primary btn-block mt-5" target="_blank">
        Preview questionnaire
      </a>

      <a href="#" class="btn btn-outline-primary btn-block" @click.prevent="showEmailPreview">Preview email</a>

      <form ref="emailPreviewForm" method="POST" target="_blank" :action="emailPreviewUrlBase">
        <input name="recipient_name" type="hidden" :value="formData.recipients[0].name" />
        <input name="survey_template_id" type="hidden" :value="survey.id" />
        <input name="message" type="hidden" :value="formData.message" />
        <input name="title" type="hidden" :value="formData.title" />
        <input name="greeting" type="hidden" :value="formData.greeting" />
        <input name="salutations" type="hidden" :value="formData.salutations" />
        <input name="contact_email" type="hidden" :value="formData.contactEmail" />
        <input name="csrf_token" type="hidden" :value="csrfToken" />
      </form>
    </b-col>
  </b-row>
</template>

<script>
import { escape } from 'lodash';
import { BRow, BCol } from 'bootstrap-vue';
import { mapGetters } from 'vuex';

export default {
  name: 'Review',
  components: {
    BCol,
    BRow,
  },
  props: {
    emailPreviewUrlBase: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    survey: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      csrfToken: 'csrfToken',
      featureFlags: 'featureFlags',
    }),
  },
  methods: {
    newLineToBr(string) {
      return escape(string).replace(/\n/g, '<br>');
    },
    showEmailPreview() {
      this.$refs.emailPreviewForm.submit();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/design/colors';

.review {
  font-size: 16px;

  &-group {
    margin-bottom: 21px;
    max-height: 69px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &-label {
    color: $color-oslo-gray;
    font-size: 14px;
  }
}
</style>
